import { Slot } from '@bcraft-frontend-lib/slots'

import { ISlotViewItem } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'

type CasinoSlot = Slot | ISlotViewItem

type PopularSlotMatcher = {
  keywords: string[]
  externalIdParts: string[]
}

export const CASINO_POPULAR_SLOTS: PopularSlotMatcher[] = [
  {
    keywords: ['sweet bonanza'],
    externalIdParts: ['sweetbonanza', 'vs20fruitsw'],
  },
  {
    keywords: ['big bass bonanza', 'bigger bass bonanza'],
    externalIdParts: ['bigbassbonanza', 'biggerbassbonanza', 'vs12bbb'],
  },
  {
    keywords: ['hot hot fruit', 'hot fruit'],
    externalIdParts: ['hothotfruit', 'sghothotfruit'],
  },
  {
    keywords: ['chilli heat', 'chili heat'],
    externalIdParts: ['chilliheat', 'vs25chilli'],
  },
]

const getSlotIdentity = (slot: CasinoSlot) => {
  const isLegacySlot = 'gameName' in slot
  const name = (isLegacySlot ? slot.gameName : slot.name) || ''
  const externalId = (isLegacySlot ? slot.gameId : slot.externalId) || ''
  const id = isLegacySlot ? slot.gameId || slot.id || name : String(slot.id)

  return {
    id,
    name: name.toLowerCase(),
    externalId: externalId.toLowerCase(),
  }
}

const isPopularSlotMatch = (slot: CasinoSlot, matcher: PopularSlotMatcher) => {
  const { name, externalId } = getSlotIdentity(slot)

  if (matcher.keywords.some(keyword => name.includes(keyword))) {
    if (matcher.keywords.includes('sweet bonanza') && name.includes('candyland')) {
      return false
    }

    return true
  }

  return matcher.externalIdParts.some(part => externalId.includes(part))
}

export const sortCasinoPopularSlotsFirst = <T extends CasinoSlot>(slots: T[]): T[] => {
  if (!slots.length) {
    return slots
  }

  const usedIds = new Set<string>()
  const popularSlots: T[] = []

  CASINO_POPULAR_SLOTS.forEach(matcher => {
    const matchedSlot = slots.find(slot => {
      const { id } = getSlotIdentity(slot)

      if (usedIds.has(id)) {
        return false
      }

      return isPopularSlotMatch(slot, matcher)
    })

    if (matchedSlot) {
      popularSlots.push(matchedSlot)
      usedIds.add(getSlotIdentity(matchedSlot).id)
    }
  })

  const restSlots = slots.filter(slot => !usedIds.has(getSlotIdentity(slot).id))

  return [...popularSlots, ...restSlots]
}

export const isCasinoDefaultFilters = (filters: {
  searchString: string
  selectedCategories: string[]
  selectedProviders: string[]
}) => {
  const hasSearch = Boolean(filters.searchString.trim())
  const hasProvider = filters.selectedProviders.some(provider => Boolean(provider))
  const isAllCategory =
    !filters.selectedCategories.length ||
    (filters.selectedCategories.length === 1 && filters.selectedCategories[0] === 'all')

  return !hasSearch && !hasProvider && isAllCategory
}
